import { ComponentType, Fragment } from 'react';

export const StepsSummary = () => {
  const steps = [
    {
      name: 'Select a plan',
      description: 'Select the best pricing model',
      icon: PricingIcon,
    },
    {
      name: 'Business info',
      description: 'Tell us about your business goals',
      icon: BusinessIcon,
    },
    {
      name: 'Recomended segments',
      description: "We'll recommend high impact segments for targeting",
      icon: SegmentsIcon,
    },
    {
      name: 'Integrate services',
      description: 'Connect segments with all your marketing channels',
      icon: ConnectServicesIcon,
    },
  ];
  return (
    <div className="flex flex-col items-center mt-12 lg:flex-row">
      {steps.map((step, index) => (
        <Fragment key={index}>
          <StepCard {...step} />
          <>
            {index !== steps.length - 1 && (
              <span className="rotate-90 lg:rotate-0">
                <ForwardIcon />
              </span>
            )}
          </>
        </Fragment>
      ))}
    </div>
  );
};

function StepCard({
  name,
  description,
  icon: Icon,
}: {
  name: string;
  description: string;
  icon: ComponentType;
}) {
  return (
    <div className="shadow-md rounded-2xl bg-white border border-solid border-segments-darker-gray lg:w-[270px] h-[195px] flex flex-col items-center justify-center space-y-3 px-4 w-full">
      <Icon />
      <div className="text-center">
        <p className="font-bold">{name}</p>
        <p className="text-segments-13px">{description}</p>
      </div>
    </div>
  );
}

function BusinessIcon() {
  return (
    <svg width="81" height="80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".1"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M62.405 28.095H46.938V12.63A6.629 6.629 0 0 0 40.31 6H13.795a6.629 6.629 0 0 0-6.628 6.629v57.447a2.21 2.21 0 0 0 2.21 2.21h14.361a1.105 1.105 0 0 0 1.105-1.105V61.3c0-1.19.914-2.21 2.103-2.27a2.21 2.21 0 0 1 2.316 2.207v9.943a1.105 1.105 0 0 0 1.105 1.105h36.457a2.21 2.21 0 0 0 2.21-2.21V34.724a6.629 6.629 0 0 0-6.63-6.629ZM16.292 63.43a2.209 2.209 0 1 1-.573-4.38 2.209 2.209 0 0 1 .573 4.38Zm0-11.048A2.21 2.21 0 1 1 15.72 48a2.21 2.21 0 0 1 .573 4.382Zm0-11.048a2.21 2.21 0 1 1-.573-4.381 2.21 2.21 0 0 1 .573 4.381Zm0-11.047a2.21 2.21 0 1 1-.573-4.382 2.21 2.21 0 0 1 .573 4.382Zm0-11.048a2.21 2.21 0 1 1-.573-4.383 2.21 2.21 0 0 1 .573 4.383ZM27.34 52.382a2.209 2.209 0 1 1-.574-4.38 2.209 2.209 0 0 1 .574 4.38Zm0-11.048a2.209 2.209 0 1 1-.574-4.38 2.209 2.209 0 0 1 .574 4.38Zm0-11.047a2.209 2.209 0 1 1-.574-4.38 2.209 2.209 0 0 1 .574 4.38Zm0-11.048a2.21 2.21 0 1 1-.573-4.382 2.21 2.21 0 0 1 .573 4.382Zm11.047 44.19a2.208 2.208 0 1 1-.573-4.379 2.208 2.208 0 0 1 .573 4.38Zm0-11.047a2.209 2.209 0 1 1-.573-4.38 2.209 2.209 0 0 1 .573 4.38Zm0-11.048a2.209 2.209 0 1 1-.573-4.38 2.209 2.209 0 0 1 .573 4.38Zm0-11.047a2.209 2.209 0 1 1-.573-4.38 2.209 2.209 0 0 1 .573 4.38Zm0-11.048a2.21 2.21 0 1 1-.573-4.382 2.21 2.21 0 0 1 .573 4.382Zm25.675 48.628H46.938V32.514h15.467a2.21 2.21 0 0 1 2.21 2.21v32.59a.552.552 0 0 1-.553.553Zm-6.076-8.839a2.21 2.21 0 1 0 0 4.42 2.21 2.21 0 0 0 0-4.42Zm-1.228-10.675a2.21 2.21 0 1 1 2.455 3.675 2.21 2.21 0 0 1-2.455-3.675Zm1.228-11.42a2.21 2.21 0 1 0 0 4.42 2.21 2.21 0 0 0 0-4.42ZM47.92 59.402a2.21 2.21 0 1 1 2.455 3.674 2.21 2.21 0 0 1-2.455-3.674Zm1.228-11.42a2.21 2.21 0 1 0 0 4.42 2.21 2.21 0 0 0 0-4.42ZM47.92 37.305a2.21 2.21 0 1 1 2.455 3.675 2.21 2.21 0 0 1-2.455-3.675Z"
        fill="#125970"
      />
      <path
        d="M55.985 46a9.818 9.818 0 1 0 0 19.635 9.818 9.818 0 0 0 0-19.635Z"
        stroke="#125970"
        strokeWidth="4"
        strokeMiterlimit="10"
      />
      <path
        d="M63.31 63.144 70.165 70"
        stroke="#125970"
        strokeWidth="4"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </svg>
  );
}

function SegmentsIcon() {
  return (
    <svg width="81" height="80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        opacity=".1"
        d="M56.831 39.178c0-2.018.808-3.955 2.246-5.382a7.698 7.698 0 0 1 5.423-2.23v-9.238c0-.875-.35-1.714-.973-2.332a3.334 3.334 0 0 0-2.349-.966H48.6a7.564 7.564 0 0 0 .571-7.905 7.635 7.635 0 0 0-2.824-3.012 7.711 7.711 0 0 0-7.984 0 7.635 7.635 0 0 0-2.825 3.012 7.565 7.565 0 0 0 .572 7.905H23.53c-.881 0-1.726.347-2.349.966a3.285 3.285 0 0 0-.973 2.332v9.233a7.7 7.7 0 0 0-5.314 2.087 7.588 7.588 0 0 0-2.385 5.155 7.578 7.578 0 0 0 1.869 5.36 7.687 7.687 0 0 0 5.084 2.59.82.82 0 0 1 .53.26c.138.149.215.344.216.546v12.144c0 .874.35 1.713.973 2.331A3.334 3.334 0 0 0 23.53 63h37.648c.881 0 1.726-.347 2.349-.966a3.285 3.285 0 0 0 .973-2.331V47.597a.851.851 0 0 0-.225-.573.864.864 0 0 0-.554-.274 7.69 7.69 0 0 1-4.911-2.471 7.582 7.582 0 0 1-1.979-5.102Z"
        fill="#125970"
      />
      <path
        d="M70.5 58c0-6.625-5.375-12-12-12s-12 5.375-12 12 5.375 12 12 12 12-5.375 12-12Z"
        stroke="#125970"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="M58.5 53v10M63.5 58h-10"
        stroke="#125970"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function ConnectServicesIcon() {
  return (
    <svg width="81" height="80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M55.834 68h-4a6 6 0 1 1 0-12h4m6 0h4a6 6 0 1 1 0 12h-4"
        stroke="#125970"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M53.039 62h11.713"
        stroke="#125970"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect
        opacity=".1"
        x="10.834"
        y="52"
        width="18"
        height="18"
        rx="7"
        fill="#125970"
      />
      <rect
        opacity=".1"
        x="13.834"
        y="34"
        width="12"
        height="12"
        rx="5"
        fill="#125970"
      />
      <rect
        opacity=".1"
        x="10.834"
        y="10"
        width="18"
        height="18"
        rx="7"
        fill="#125970"
      />
      <rect
        opacity=".1"
        x="34.834"
        y="13"
        width="12"
        height="12"
        rx="5"
        fill="#125970"
      />
      <rect
        opacity=".1"
        x="34.834"
        y="34"
        width="12"
        height="12"
        rx="5"
        fill="#125970"
      />
      <rect
        opacity=".1"
        x="34.834"
        y="55"
        width="12"
        height="12"
        rx="5"
        fill="#125970"
      />
      <rect
        opacity=".1"
        x="52.834"
        y="10"
        width="18"
        height="18"
        rx="7"
        fill="#125970"
      />
      <rect
        opacity=".1"
        x="55.834"
        y="34"
        width="12"
        height="12"
        rx="5"
        fill="#125970"
      />
    </svg>
  );
}

function ForwardIcon() {
  return (
    <svg width="27" height="26" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="m9.985 21.024 8.283-7.099a1.219 1.219 0 0 0 0-1.85L9.985 4.977c-.79-.678-2.012-.116-2.012.925V20.1c0 1.041 1.221 1.603 2.012.924Z"
        fill="#E1E1E1"
      />
    </svg>
  );
}

function PricingIcon() {
  return (
    <svg width="81" height="80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="28.125"
        y="10"
        width="24"
        height="58"
        rx="4"
        fill="#125970"
        opacity=".1"
      />
      <rect
        x="55.125"
        y="16"
        width="18"
        height="48"
        rx="4"
        fill="#125970"
        opacity=".1"
      />
      <rect
        x="7.125"
        y="16"
        width="18"
        height="48"
        rx="4"
        fill="#125970"
        opacity=".1"
      />
      <path
        d="M70 58c0-6.625-5.375-12-12-12s-12 5.375-12 12 5.375 12 12 12 12-5.375 12-12Z"
        stroke="#125970"
        strokeWidth="3"
        strokeMiterlimit="10"
      />
      <path
        d="m64 53-8.4 10-3.6-4"
        stroke="#125970"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
